import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../store';
import { toggle } from '../../../store/popups/print';
import { IPrintButtonProps, PrintButton } from './index';

type TDispatchProps = Pick<IPrintButtonProps, 'openPrintModal'>;
type TOwnProps = Pick<IPrintButtonProps, 'className'>;

function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    openPrintModal: () => dispatch(toggle(true)),
  };
}

export const PrintButtonContainer = connect<{}, TDispatchProps, TOwnProps>(() => ({}), mapDispatchToProps)(PrintButton);
